export default __webpack_public_path__ + "static/media/z050ma7d.3973ce7d.mp3";